import { useSearchParamsContext } from 'modules/linkExpirationManagement/contexts';
import { HeaderCell } from './HeaderCell';
import { GRID_LAYOUT, StyledHeaderRow } from './Table.styled';
import { HelpToggletip } from 'ui/tooltip';

export const TABLE_HEADER_TEXT = {
  clickLinkBehaviorLabel: 'Click link behavior',
  effectiveDateLabel: 'Effective date',
  effectiveDateTooltipContent:
    'The exact date the "Redirect location" will take effect for the project.',
  projectCellName: 'projectName',
  projectLabel: 'Project',
  redirectLocationLabel: 'Redirect location',
};

const {
  clickLinkBehaviorLabel,
  effectiveDateLabel,
  projectCellName,
  projectLabel,
  redirectLocationLabel,
} = TABLE_HEADER_TEXT;

export const TableHeader = () => {
  const { handleSort, sortBy, sortDirection } = useSearchParamsContext();

  return (
    <StyledHeaderRow gridLayout={GRID_LAYOUT}>
      <HeaderCell
        name={projectCellName}
        sortBy={sortBy}
        sortDirection={sortDirection}
        onClick={handleSort}
      >
        {projectLabel}
      </HeaderCell>
      <HeaderCell>{clickLinkBehaviorLabel}</HeaderCell>
      <HeaderCell>{redirectLocationLabel}</HeaderCell>
      <HeaderCell>
        <span>{effectiveDateLabel}</span>
        <HelpToggletip tooltipContent={TABLE_HEADER_TEXT.effectiveDateTooltipContent} />
      </HeaderCell>
    </StyledHeaderRow>
  );
};
